// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"331":"c7c32b95","689":"783cff7f","968":"8f63b47e"}[chunkId] + ".chunk.js";
};